import ComponentMixin from './complex'
import ReactiveMixin from '../mashup-builder/reactives'

export default {
  mixins: [ComponentMixin, ReactiveMixin],
}
